import { render, staticRenderFns } from "./UniversitiesPlans.vue?vue&type=template&id=30ba4e1b&scoped=true&"
import script from "./UniversitiesPlans.vue?vue&type=script&lang=js&"
export * from "./UniversitiesPlans.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UniversitiesPlans.vue?vue&type=style&index=1&lang=css&"
import style2 from "./UniversitiesPlans.vue?vue&type=style&index=2&id=30ba4e1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba4e1b",
  null
  
)

export default component.exports